import { BASE_URL_API } from "../../../constants";
import fetcher from "../../../utils/fetcher";

export const _api_get_model = (type = null) => {
    const url = `${BASE_URL_API}/task/task_definition/list${
        type ? "?type=" + type : ""
    }`;
    return fetcher(url, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_departure = ({ id_user = null }) => {
    const url = `${BASE_URL_API}/offboarding/user/${id_user}/step/contract`;
    return fetcher(url, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_notice_period = () => {
    const url = `${BASE_URL_API}/offboarding/notice_periods/list`;
    return fetcher(url, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_list_reasons = () => {
    const url = `${BASE_URL_API}/offboarding/reasons/list`;
    return fetcher(url, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_justificatifs = ({ id_user }) => {
    const url = `${BASE_URL_API}/offboarding/user/${id_user}/step/document_and_details`;
    return fetcher(url, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_post_step_departure = ({ id_user, body }) => {
    const url = `${BASE_URL_API}/offboarding/user/${id_user}/step/contract`;
    return fetcher(url, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(body),
    });
};

export const _api_post_step_document_and_details = ({ id_user, body }) => {
    const url = `${BASE_URL_API}/offboarding/user/${id_user}/step/document_and_details`;
    return fetcher(url, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(body),
    });
};

// SOLES
export const _api_get_soldes = ({ id_user }) => {
    const url = `${BASE_URL_API}/offboarding/user/${id_user}/step/balances`;
    return fetcher(url, {
        method: "GET",
        credentials: "include",
    });
};
// equipments
export const _api_get_equipments = ({ id_user }) => {
    const url = `${BASE_URL_API}/offboarding/user/${id_user}/step/resources`;
    return fetcher(url, {
        method: "GET",
        credentials: "include",
    });
};
// tasks
export const _api_post_tasks_start_offboarding = ({ id_user, tasks }) => {
    const url = `${BASE_URL_API}/offboarding/user/${id_user}/step/start_offboarding`;
    return fetcher(url, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({ tasks }),
    });
};
export const _api_delete_process_offboarding = ({ id_user }) => {
    const url = `${BASE_URL_API}/offboarding/user/${id_user}/cancel`;
    return fetcher(url, {
        method: "DELETE",
        credentials: "include",
    });
};
// offboarding
export const _getAllOffboardingAgencies = async () => {
    return fetcher(BASE_URL_API + "/offboarding/agencies", {
        method: "GET",
        credentials: "include",
    });
};

export const _getAllOffBoardingUsers = (agencies) => {
    return fetcher(
        `${BASE_URL_API}/offboarding/agency/${agencies}/filter/users`,
        {
            method: "GET",
            credentials: "include",
        }
    );
};

export const _getAllOffBoardingUsersByAgency = (agencies) => {
    return fetcher(`${BASE_URL_API}/offboarding/agency/${agencies}/users`, {
        method: "GET",
        credentials: "include",
    });
};
export const _getOffboardingUserDetail = (id_user) => {
    return fetcher(`${BASE_URL_API}/user/${id_user}/tasks?type=offboarding`, {
        method: "GET",
        credentials: "include",
    });
};
export const _getOffboardingArchiveduser = async (id_user) => {
    return fetcher(
        `${BASE_URL_API}/archived-offboarding/user/${id_user}/details`,
        {
            method: "GET",
            credentials: "include",
        }
    );
};

export const relance_offboarding_employee = async (data) => {
    return fetcher(
        BASE_URL_API + `/offboarding/user/${data?.id}/step/notify_user`,

        {
            method: "POST",
            credentials: "include",
        }
    );
};

export const _archive_offboarding_user = (data) => {
    const id_user = data?.user?.user?.id;
    const change_date = data?.user?.archivePayloadToBack?.datefrom;
    const new_status = data?.user?.archivePayloadToBack?.status;
    return fetcher(
        BASE_URL_API + `/onboarding/user/${id_user}/step/change_status`,
        {
            method: "PATCH",
            // credentials: "include",
            headers: {
                "Content-Type": "application/json", // Définir le type de contenu
            },
            body: JSON.stringify({
                new_status, // Envoyer new_status dans le body
                change_date, // Envoyer change_date dans le body
            }),
        }
    );
};
export const _api_get_list_offboarding_users = () => {
    return fetcher(`${BASE_URL_API}/offboarding/users/list`, {
        method: "GET",
        credentials: "include",
    });
};
export const _api_get_list_types_status = ({ id_user }) => {
    return fetcher(`${BASE_URL_API}/user/${id_user}/status_changes/list`, {
        method: "GET",
        credentials: "include",
    });
};
export const _api_patch_change_status = ({ id_user, data }) => {
    return fetcher(
        `${BASE_URL_API}/onboarding/user/${id_user}/step/change_status`,
        {
            method: "PATCH",
            credentials: "include",
            body: JSON.stringify({
                new_status: data.new_status,
                change_date: data.change_date,
            }),
        }
    );
};

export const _api_offboarding_user_for_export = () => {
    return fetcher(`${BASE_URL_API}/offboarding/users-department/list`, {
        method: "GET",
        credentials: "include",
    });
};
export const _api_getOffboardingTypeStatus = (id_user) => {
    return fetcher(`${BASE_URL_API}/user/${id_user}/status_changes/list`, {
        method: "GET",
        credentials: "include",
    });
};
export const _changeStatusOffboardingUser = (data) => {
    const { id_user, id_type, startDate } = data;
    return fetcher(
        `${BASE_URL_API}/onboarding/user/${id_user}/step/change_status`,
        {
            method: "PATCH",
            credentials: "include",
            body: JSON.stringify({
                new_status: id_type,
                change_date: startDate,
            }), // Envoyer new_status et change_date dans le body
        }
    );
};

export const relance_onboarding_user_from_offboarding = (data) => {
    console.log({ zelensky: data });
};

export const _changeStartDateOffboardingUser = (data) => {
    const id_user = data?.id_user;
    return fetcher(
        `${BASE_URL_API}/offboarding/user/${id_user}/udpate_departure_date`,
        {
            method: "PUT",
            credentials: "include",
            body: JSON.stringify({
                departure_date: data.data.startDate,
            }),
        }
    );
};
